import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import { SnackSettings_SnackSettingsPage_Query } from "./query";

type Props = {
	hotelID: string;
};

export const useSnackSettingsQuery = ({ hotelID }: Props) => {
	const { data } = useCustomSuspenseQuery(SnackSettings_SnackSettingsPage_Query, {
		variables: {
			hotelID,
		},
	});

	return {
		data,
	};
};
